import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Button} from '@components/common/button/button'
import {FilterRow} from '../../filter/filter-row'
import {StatsTimelineFilter} from '../../filter/filter-spoiler'
import {useStatsTimelineStore} from '../../stats-timeline-store'
import FilterSVG from './svg/filter.svg'
import TriangleSVG from './svg/triangle.svg'

type Props = {
  selected: boolean
}
const TwWrapper = tw.div<Props>`
  flex
  hover:text-third-old
  active:text-main-old
  whitespace-nowrap
   ${p => (p.selected ? 'text-accent-old' : 'text-obscure-old')}
`

const TwFilter = tw.div`
  ml-2
  hover:underline
  cursor-pointer
  text-action-default
  text-14
  flex
`

const TwFilterPanel = tw.div`
  w-full
  bg-main-old
  pt-8
  pl-8
  pr-12
  pb-8
  border-main-old
  border-solid
  border
  overflow-auto
  rounded-4
`

type PropsTriangle = {
  $selected: boolean
}

const TwTriangle = tw.div<PropsTriangle>`
  ml-6
  ${({$selected}) =>
    $selected ? 'transform rotate-180 flex self-start mt-8' : null}
`

const TwBorder = tw.div`
  h-24
  mx-16
  border-solid
  border-1
  border-main-old
`

export const TopMenu = observer(() => {
  const [state, store] = useStatsTimelineStore()

  const resetFilter = () => {
    store.resetFilter()
    store.resetItemsToLoad()
    state.showFilter = false
  }

  return (
    <TwFilterPanel>
      <div className="flex">
        <TwWrapper
          selected={!!store.activeFilter.length}
          onClick={() => store.toggleFilter()}
        >
          <FilterSVG />
          <TwFilter>
            {state.view === 'table' && Lang.msg.statsTimeline.filteringTable}
            {state.view === 'card' && Lang.msg.statsTimeline.filteringEvents}
            <TwTriangle $selected={state.showFilter}>
              <TriangleSVG />
            </TwTriangle>
          </TwFilter>
        </TwWrapper>
        {(store.activeFilter.length > 0 ||
          (state.filter.title?.length ?? 0) > 0) && (
          <>
            <TwBorder />
            <Button $small onClick={resetFilter}>
              {Lang.msg.statsTimeline.reset}
            </Button>
            <FilterRow />
          </>
        )}
      </div>
      {state.showFilter && <StatsTimelineFilter initialFilter={state.filter} />}
    </TwFilterPanel>
  )
})
